import {MemberDirectSurveysState} from './surveys.interface';

export const memberDirectSurveysState: MemberDirectSurveysState = {
    preauthorizedSurvey: false
};
